<template>
  <div class="page-container">
    <!-- 内容层（浮在背景之上） -->
    <div class="content-layer">
      <!-- Banner 装饰元素 -->
      <div class="banner"></div>

      <div class="account">
        <input type="text" placeholder="输入手机号码" v-model="account" />
      </div>
      <div class="account-code">
        <input type="text" placeholder="输入验证码" v-model="captcha" />
      </div>
        <div class="get-code" @click="code">
          {{ text }}
        </div>
         <div class="checkgroup">
         <input
                    type="checkbox"
                    class="checkbox"
                    v-model="isAgree"
                    id="agreeCheckbox"
                  />

                   <label for="agreeCheckbox" class="protocol_text ml-8"
                              >我已阅读并同意</label
                            >
                            <span class="protocol_text">
                              <span @click="userAgree('userinfo')" class="font_pro"
                                >《用户协议》</span
                              ><span @click="userAgree('userprivacyinfo')" class="font_pro"
                                >《隐私协议》</span
                              >
                            </span>
         </div>



    </div>
    <div class="login" @click="handleLogin">
       <span>登录/注册会员</span>
    </div>
    <VerifyPopup ref="verify" @success="onVerifySuccess"></VerifyPopup>
  </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import { loginMobile, registerVerify, register } from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { getLogo } from "@api/public";
import cookie from "@utils/store/cookie";
import { VUE_APP_API_URL } from "@utils";
import VerifyPopup from "@components/VerifyPopup.vue";

const BACK_URL = "login_back_url";

export default {
  name: "Login",
  mixins: [sendVerifyCode],
  components: {
    VerifyPopup,
  },
  data: function () {
    return {
      isAgree: false,
      account: "",
      captcha: "",
      formItem: 1,
      type: "login",
      logoUrl: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      isShowCode: false,
    };
  },
  mounted: function () {
    //  this.getLogoImage();
  },
  methods: {
    handleLogin() {
      if (this.formItem == 1) {
        this.loginMobile();
      } else {
        this.register();
      }
    },
    userAgree(type) {
      if (type === "userinfo") {
        window.location.href =
          "https://h5.merchant.cathaytour.com/user_agreement_for_admin.html";
      } else {
        window.location.href =
          "https://h5.merchant.cathaytour.com/user_privacy.html";
      }
    },
    again() {
      this.codeUrl =
        VUE_APP_API_URL +
        "/sms_captcha?" +
        "key=" +
        this.keyCode +
        Date.parse(new Date());
    },
    async getLogoImage() {
      let that = this;
      getLogo(2).then((res) => {
        that.logoUrl = res.data.logo_url;
      });
    },
    async loginMobile() {
      var that = this;
      const { account, captcha } = that;
      // 1. 先判断手机号是否录入
      if (!account) {
        return that.$dialog.error("请输入手机号码");
      }
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message()),
            ],
          })
          .validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      // 2. 再判断验证码是否录入
      if (!captcha) {
        return that.$dialog.error("请输入验证码");
      }
      try {
        await that
          .$validator({
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码")),
            ],
          })
          .validate({ captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      // 3. 最后判断是否勾选协议
      if (!that.isAgree) {
        return that.$dialog.error("请勾选用户隐私协议");
      }
      loginMobile({
        phone: that.account,
        captcha: that.captcha,
        spread: cookie.get("spread"),
      })
        .then((res) => {
          let data = res.data;
          let expires_time = Date.now() + 7 * 24 * 60 * 60 * 1000; // 默认7天有效期
          if (data.expires_time) {
            expires_time = data.expires_time.substring(0, 19);
            expires_time = expires_time.replace(/-/g, "/");
            expires_time = new Date(expires_time).getTime() - 28800000;
          }
          const datas = {
            token: data.token,
            expires_time: expires_time,
          };
          that.$store.commit("LOGIN", datas);
          cookie.remove(BACK_URL);
          // 登录成功后跳转到个人中心，溯源码会在User.vue中自动回填
          that.$router.replace({ name: "User" });
        })
        .catch((res) => {
          that.$dialog.error(res.msg);
        });
    },
    async register() {
      var that = this;
      const { account, captcha, password } = that;
      if (!that.isAgree) {
        return that.$dialog.error("请勾选用户隐私协议");
      }
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message()),
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码")),
            ],
            password: [
              required(required.message("密码")),
              attrs.range([6, 16], attrs.range.message("密码")),
              alpha_num(alpha_num.message("密码")),
            ],
          })
          .validate({ account, captcha, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      register({
        account: that.account,
        captcha: that.captcha,
        password: that.password,
        spread: cookie.get("spread"),
      })
        .then((res) => {
          that.$dialog.success(res.msg);
          that.formItem = 1;
        })
        .catch((res) => {
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      var that = this;
      const { account } = that;
      // 先判断手机号是否录入
      if (!account) {
        return that.$dialog.error("请输入手机号码");
      }
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message()),
            ],
          })
          .validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (that.formItem == 2) that.type = "register";
      that.$refs.verify.show();
    },
    onVerifySuccess() {
      var that = this;
      registerVerify({
        phone: that.account,
        type: that.type,
      })
        .then((res) => {
          // 后端返回: { code: 200, message: null, data: "发送成功" }
          that.$dialog.success(
            res.data || res.msg || res.message || "发送成功"
          );
          that.sendCode();
        })
        .catch((res) => {
          if (res.data && (res.data.status === 402 || res.data.code === 402)) {
            that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
            that.isShowCode = true;
          }
          that.$dialog.error(
            res.msg ||
              (res.data && res.data.msg) ||
              (res.data && res.data.message) ||
              "发送失败"
          );
        });
    },
  },
};
</script>
<style scoped>
/* ===== 容器：占满视口 ===== */
.page-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
}

/* ===== 内容层：相对定位，在背景之上 ===== */
.content-layer {
  position: relative;
  width: 100%;
  min-height: 100vh;
  z-index: 1;
  aspect-ratio: 490 / 942;
  margin: 0 auto;
}

/* ===== Banner ===== */
.banner {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(115 / 490 * 100vw);
  width: calc(201 / 490 * 100vw);
  height: calc(61 / 490 * 100vw);
  background: url('https://img.js.design/assets/img/6a97ec124c50ce0b338bb99c.png#43987d841c079d96707f6ba69f1ed022') no-repeat center center;
  background-size: 100% 100%;
}

/* ===== 账号输入框 ===== */
.account {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(261 / 490 * 100vw);
  width: calc(384 / 490 * 100vw);
  height: calc(60 / 490 * 100vw);
  border-radius: 8px;
  border: 1.5px solid rgba(94, 94, 94, 1);
  z-index: 2;
}

.account input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  padding: 0 15px;
  box-sizing: border-box;
  font-size: calc(18 / 490 * 100vw);
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 24.7px;
  color: rgba(44, 44, 44, 1);
  text-align: left;
  vertical-align: top;
}

.account input::placeholder {
  font-size: calc(18 / 490 * 100vw);
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 24.7px;
  color: rgba(44, 44, 44, 1);
  text-align: left;
  vertical-align: top;
  opacity: 1;
}

/* ===== 验证码输入框 ===== */
.account-code {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(338 / 490 * 100vw);
  width: calc(384 / 490 * 100vw);
  height: calc(60 / 490 * 100vw);
  border-radius: 8px;
  border: 1.5px solid rgba(94, 94, 94, 1);
  z-index: 2;
}

.account-code input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  padding: 0 15px;
  box-sizing: border-box;
  font-size: calc(18 / 490 * 100vw);
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 24.7px;
  color: rgba(44, 44, 44, 1);
  text-align: left;
  vertical-align: top;
}

.account-code input::placeholder {
  font-size: calc(18 / 490 * 100vw);
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 24.7px;
  color: rgba(44, 44, 44, 1);
  text-align: left;
  vertical-align: top;
  opacity: 1;
}

/* ===== 获取验证码按钮 ===== */
.get-code {
  position: absolute;
  right: calc(64 / 490 * 100vw);
  top: calc(357 / 490 * 100vw);
  width: calc(98 / 490 * 100vw);
  height: calc(22 / 490 * 100vw);
  font-size: calc(18 / 490 * 100vw);
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 21.1px;
  color: rgba(0, 0, 0, 1);
  text-align: right;
  vertical-align: top;
  z-index: 2;
  cursor: pointer;
}

/* ===== 用户协议勾选组 ===== */
.checkgroup {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(445 / 490 * 100vw);
  width: calc(384 / 490 * 100vw);
  height: calc(16 / 490 * 100vw);
  opacity: 1;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  font-size: calc(14 / 490 * 100vw);
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 16.41px;
  color: rgba(94, 94, 94, 1);
  text-align: left;
  vertical-align: top;
}

.checkgroup .checkbox {
  width: calc(16 / 490 * 100vw);
  height: calc(16 / 490 * 100vw);
  flex-shrink: 0;
  flex-grow: 0;
  margin-right: 4px;
  /* 未勾选时：圆形边框 */
  appearance: none;
  -webkit-appearance: none;
  border: 1.5px solid rgba(255, 255, 255, 1);
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  opacity: 1;
  aspect-ratio: 1 / 1;
  box-sizing: border-box;
}

/* 选中时使用自定义背景图 */
.checkgroup .checkbox:checked {
  appearance: none;
  -webkit-appearance: none;
  width: calc(16 / 490 * 100vw);
  height: calc(16 / 490 * 100vw);
  background: url(../../assets/images/checkboxselected.png) no-repeat center center;
  background-size: 100% 100%;
  border: none;
  outline: none;
  cursor: pointer;
  opacity: 1;
}

.checkgroup .protocol_text {
  font-size: calc(14 / 490 * 100vw);
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 16.41px;
  color: rgba(0, 0, 0, 1);
  text-align: left;
  vertical-align: top;
}

.checkgroup .font_pro {
  font-size: calc(14 / 490 * 100vw);
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 16.41px;
  color: rgba(99, 79, 64, 1);
  text-align: left;
  vertical-align: top;
  cursor: pointer;
}

/* ===== 登录/注册按钮 ===== */
.login {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(471 / 490 * 100vw);
  width: calc(384 / 490 * 100vw);
  height: calc(60 / 490 * 100vw);
  opacity: 1;
  border-radius: 8px;
  background: rgba(127, 98, 73, 1);
  font-size: calc(22 / 490 * 100vw);
  font-weight: 500;
  letter-spacing: 0px;
  line-height: calc(60 / 490 * 100vw);
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
  cursor: pointer;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.code img {
  width: 100%;
  height: 100%;
}
</style>
